import { Box, Divider, Typography } from "@mui/material";
import React, { useState } from "react";
import BulkSMS from "./bulk/BulkSMS";
import Compose from "./compose/Compose";
import Customize from "./customize/Customize";
import Split from "./split/Split";
import { useGetCustomerLogDeleteKeyQuery } from "../../../store/services/reportApi";

const PILL_HEIGHT = 35; // single source of truth for all selector pill heights

const smsoption = [
  {
    id: "bulk",
    label: "Bulk SMS",
    bg: "#E6F1FB",
    iconColor: "#185FA5",
    selectedBorder: "#185FA5",
    selectedText: "#185FA5",
    icon: (
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 4h16v12H4z" />
        <path d="M4 8h16" />
        <path d="M8 16v4" />
        <path d="M16 16v4" />
        <path d="M8 20h8" />
      </svg>
    ),
  },
  {
    id: "compose",
    label: "Compose SMS",
    bg: "#EAF3DE",
    iconColor: "#3B6D11",
    selectedBorder: "#3B6D11",
    selectedText: "#3B6D11",
    icon: (
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <line x1="9" y1="10" x2="15" y2="10" />
        <line x1="9" y1="14" x2="13" y2="14" />
      </svg>
    ),
  },
  {
    id: "customize",
    label: "Customize SMS",
    bg: "#FAEEDA",
    iconColor: "#854F0B",
    selectedBorder: "#854F0B",
    selectedText: "#854F0B",
    icon: (
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
  },
  {
    id: "split",
    label: "Split SMS",
    bg: "#FAECE7",
    iconColor: "#993C1D",
    selectedBorder: "#993C1D",
    selectedText: "#993C1D",
    icon: (
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="8" y1="6" x2="21" y2="6" />
        <line x1="8" y1="12" x2="21" y2="12" />
        <line x1="8" y1="18" x2="21" y2="18" />
        <line x1="3" y1="6" x2="3.01" y2="6" />
        <line x1="3" y1="12" x2="3.01" y2="12" />
        <line x1="3" y1="18" x2="3.01" y2="18" />
      </svg>
    ),
  },
];

const SMSComponent = ({ service_id, onPreviewChange }) => {
  const [selectedButton, setSelectedButton] = useState(smsoption[0].id);
  const [enableSchedule, setEnableSchedule] = useState(false);
  const { data: featureKeyData } = useGetCustomerLogDeleteKeyQuery();

  const canShowSplitScheduler =
    featureKeyData?.data?.is_splitscheduler_given === true;

  const handleServiceButtonChange = (radioId) => {
    setSelectedButton(radioId);
    if (radioId === "split") setEnableSchedule(true);
    else setEnableSchedule(false);

    if (typeof onPreviewChange === "function") {
      onPreviewChange({
        entity: "",
        senderId: "",
        templateName: "",
        templateId: "",
        file: "",
        dbFile: "",
        additionalNumbers: "",
        message: "",
        smsType: "",
        schedule: "",
        allowLong: false,
        isFlash: false,
        charCount: 0,
        smsCount: 0,
      });
    }
  };

  const filteredSmsOptions = smsoption.filter((option) => {
    if (option.id === "split") {
      return canShowSplitScheduler;
    }
    return true;
  });

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Divider sx={{ bgcolor: "rgba(255,255,255,0.39)", mb: 1.5 }} />

      {/* Campaign Type Selector — compact pill with small circle icon */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          flexWrap: "nowrap",
          alignItems: "stretch", // ensures all pills stretch to same row height
        }}
      >
        {filteredSmsOptions.map((option) => {
          const isSelected = selectedButton === option.id;
          return (
            <Box
              key={option.id}
              onClick={() => handleServiceButtonChange(option.id)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.8,
                cursor: "pointer",
                px: 1.2,
                py: 0.6,
                height: PILL_HEIGHT,
                minHeight: PILL_HEIGHT,
                maxHeight: PILL_HEIGHT,
                boxSizing: "border-box",
                flexShrink: 0,
                borderRadius: "8px",
                border: isSelected
                  ? `1.5px solid ${option.selectedBorder}`
                  : "1px solid rgba(0,0,0,0.12)",
                background: isSelected ? option.bg : "rgba(255,255,255,0.7)",
                backdropFilter: "blur(8px)",
                boxShadow: isSelected
                  ? `0 2px 8px ${option.selectedBorder}33`
                  : "none",
                transition: "all 0.2s ease",
                "&:hover": {
                  border: `1.5px solid ${option.selectedBorder}`,
                  background: option.bg,
                },
              }}
            >
              {/* Small circle icon */}
              <Box
                sx={{
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  bgcolor: isSelected ? "white" : option.bg,
                  border: `1px solid ${option.selectedBorder}55`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: option.iconColor,
                  flexShrink: 0,
                }}
              >
                {option.icon}
              </Box>

              {/* Label */}
              <Typography
                sx={{
                  fontSize: "0.78rem",
                  fontWeight: isSelected ? 600 : 400,
                  color: isSelected ? option.selectedText : "rgba(0,0,0,0.7)",
                  whiteSpace: "nowrap",
                  lineHeight: 1,
                  transition: "all 0.2s ease",
                }}
              >
                {option.label}
              </Typography>
            </Box>
          );
        })}
      </Box>

      {/* Render Selected Component */}
      <Box sx={{ mt: 2 }}>
        {selectedButton === "bulk" && (
          <BulkSMS service_id={service_id} onPreviewChange={onPreviewChange} />
        )}
        {selectedButton === "compose" && (
          <Compose service_id={service_id} onPreviewChange={onPreviewChange} />
        )}
        {selectedButton === "customize" && (
          <Customize
            service_id={service_id}
            onPreviewChange={onPreviewChange}
          />
        )}
        {selectedButton === "split" && (
          <Split service_id={service_id} onPreviewChange={onPreviewChange} />
        )}
      </Box>

      <Divider sx={{ my: 2, bgcolor: "grey.500" }} />
    </Box>
  );
};

export default SMSComponent;